/** The date a receipt belongs to: the date on the receipt/bill/invoice itself,
 *  else the day its email arrived (or it was uploaded). */
interface Dated {
  invoice_date?: string | null;
  received_at?: string | null;
}

/** Local Date for sorting/formatting. A bare YYYY-MM-DD is read as a local
 *  day; `new Date("2026-10-25")` would be UTC midnight and show the day before
 *  west of Greenwich. */
export function receiptDay(r: Dated): Date | null {
  if (r.invoice_date) {
    const [y, m, d] = r.invoice_date.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  return r.received_at ? new Date(r.received_at) : null;
}

export function formatReceiptDate(r: Dated): string {
  return receiptDay(r)?.toLocaleDateString() ?? "—";
}
